import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent, FormWrapperInputComponent } from "../../../common/component/Index";
import Tour from './../../../../../models/Tour';
import { withTranslation } from "react-i18next";
import { Icon, Rate, Menu, Tooltip } from 'antd';
import Span from '../../../common/component/Span';
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { PATHS, DATE_TIME_FORMAT, TOUR, RATECODE } from '../../../../../constants/Define';
import './TourList.less';
import { FlagIcons } from '../../../common/component/TranslateButton';
import EllipsisText from '../../../common/component/EllipsisText';
import moment from 'moment';
import Wrapper from '../../../common/component/Wrapper';
import AntSelect from '../../../common/component/AntSelect';
import { AntOption } from './../../../common/component/AntSelect/index';
import Radio from '../../../common/component/Radio';
import { toArray } from 'lodash';

const ListCols = [
    'tourName', 'tourCode', 'type', 'channel', 'adultOriginalPrice', 'lengthOfTour', 'departure', 'destination', 'translations', 
    'saleStartDate', 'saleEndDate', 'stayStartDate', 'stayEndDate', 'effectiveStartDate', 'effectiveEndDate', 'voucherBookingPeriod',
    'bookingPeriod', 'cutOffDate'
];
const ModelFields = Object.getOwnPropertyNames(new Tour());
class TourList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cloneItem: {},
            isCloneModalVisible: false,
            isCopyTourTickets: undefined,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                tourName: {
                    sorter: (i, k) => i.tourName.length - k.length,
                    key: 'searchTerm',
                    fixed: 'left',
                    width: 300,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={250}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                tourCode: {
                    key: 'tourCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                lengthOfTour: {
                    render: (lengthOfTour, record) => this.getEnumLengthOfTour(lengthOfTour)
                },
                adultOriginalPrice: {
                    render: (adultOriginalPrice, record) => <Span className="prices">
                        <Span className={record.adultSalePrice ? "prices-sale" : ''}>{Func.formatMoney(adultOriginalPrice)}</Span>{`${Func.formatMoney(record.adultSalePrice)}${this.props.t(`currencySymbol`)}`}
                    </Span>
                },
                departure: {
                    key: 'departure',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (departure) => departure && departure.name,
                },
                // hotel: {
                //     key: 'hotel',
                //     width: 180,
                //     align: 'center',
                //     render: (hotel) => hotel && <Rate disabled value={hotel.rating || 0} allowHalf />,
                // },
                destination: {
                    key: 'destination',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (destination) => destination && destination.name,
                },
                type: {
                    key: 'types',
                    render: (type, data) => <Fragment>
                        {type && <div className="g-mt-5">
                                <StatusComponent color={type === 1 ? 'blue' : (type === 7 ? 'orange': 'green')}
                                    label={ type === 7 ? this.props.t(`item.vinWonder.title`) : this.props.t(`item.tour.types.${type === 1 ? 'voucher': 'tour' }`)} />
                        </div>
                        }
                    </Fragment>,
                    filters: [
                        { value: 1, text: this.props.t(`item.tour.types.voucher`) },
                        { value: 2, text: this.props.t(`item.tour.types.tour`) },
                        { value: 7, text: this.props.t(`item.vinWonder.title`) },
                    ],
                    filterMultiple: true,
                },
                channel: {
                    key: 'channel',
                    width: 120,
                    render: (channels, data) => {
                        const channelList = toArray(TOUR.CHANNELS);
                        const text = channels.map(x=> channelList.find(item => item.value === x)?.label).filter(x=> !!x).join(", "); 
                        return text;
                    },
                    filters: toArray(TOUR.CHANNELS).map(item => ({value: item.value, text: item.label})),
                    filterMultiple: true,
                },
                translations: {
                    key: 'translations',
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                createdDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                saleStartDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                saleEndDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                stayStartDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                stayEndDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                effectiveStartDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                effectiveEndDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                voucherBookingPeriod: {
                    title: this.props.t('item.tour.bookingPeriodVoucher'),
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE),
                },
                bookingPeriod: {
                    render: (text, record) => text ? text : '',
                },
                action: {
                    fixed: 'right',
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, tours, t } = this.props;
        const { titleItemTable, modelItem, componentTable, cloneItem } = this.state;
        return (
            <>
                <ListComponent
                    tableKey="tour-list"
                    scroll={{ x: 3000 }}
                    classParent="tour-list m-0"
                    classChildren="p-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    loading={{ spinning: loading, size: 'large' }}
                    dataSource={Func.getDataSource(tours || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'tour'
                    })}
                    onChange={this.props.onChange}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultPageSize: pagination.pageSize, defaultCurrent: pagination.defaultCurrent }}
                    componentTableList={{}}
                />

                <Modal 
                    title={null}
                    visible={this.state.isCloneModalVisible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okText={t(`action.clone`)}
                    cancelText={t(`action.cancel`)}
                    okButtonProps={{ disabled: typeof this.state.isCopyTourTickets !== 'boolean' }}
                    closable={false}
                    maskClosable={false}
                    bodyStyle={{border: "none"}}
                    width={416}
                    >
                        <div className='ant-modal-confirm-body d-flex'>
                            <Icon type={'question-circle'} style={{ fontSize: '20px', color: '#ffaa15' }} />
                            <div>
                                <span className='ant-modal-confirm-title'>{Func.formatValidation(t('validation.statusCode.code.15'), t(`item.tour.title`))}</span>
                                <div>
                                    {cloneItem.tourName}
                                </div>
                                <div className="mt-3">
                                    <div>Bạn có muốn sao chép VVBĐG không?</div>
                                    <Radio.Group
                                        className="mt-2"
                                        value={this.state.isCopyTourTickets}
                                        onChange={(event) => this.setState({ isCopyTourTickets: event.target.value })}
                                    >
                                        <Radio value={true} className="mr-3">Có</Radio>
                                        <Radio value={false}>Không</Radio>
                                    </Radio.Group>
                                </div>
                                <div>
                                {
                                    Object.keys(cloneItem).length && cloneItem.type !== RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.value &&
                                    <Wrapper className="col-12 mt-3">
                                        <FormWrapperInputComponent
                                            typeInput={true}
                                            isRequired={'right'}
                                            isValidation={true}
                                            messageBelowInput={true}
                                            labelTitle={t(`item.tour.lengthOfTour`)}
                                            classLabel={"col-md-5 p-0"}
                                            classInputForm={"col-md-7 pr-0"}
                                        >
                                            <Wrapper style={{ display: 'flex' }}>
                                                <AntSelect className="select-lengthOfTour"
                                                    showArrow showSearch
                                                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tour.lengthOfTour")).toLowerCase())}
                                                    value={this.state.cloneItem?.lengthOfTour}
                                                    onChange={(value) => this.setState({...this.state, cloneItem: {...this.state.cloneItem, lengthOfTour: value} })}
                                                    style={{ width: '100%' }}
                                                >
                                                    {TOUR.LENGTHOFTOUR.map((value, index) => {
                                                        return <AntOption key={index} value={value}>{this.getEnumLengthOfTour(value)}</AntOption>
                                                    })}
                                                </AntSelect>
                                            </Wrapper>
                                        </FormWrapperInputComponent>
                                    </Wrapper>
                                }
                                </div>
                            </div>
                        </div>
                </Modal>
            </>
            
        );
    }

    getEnumLengthOfTour = (value) => {
        const { t } = this.props
        let str = t(`item.tour.enumLengthOfTour`)
        if(!value) {
            return ''
        }
        const [days, nights] = value.split('.')
        var mapObj = {
            days: days || 0,
            nights: nights || 0,
            
        };
        str = str.replace(/days|nights/gi, function(matched){
            return mapObj[matched];
        });
        return str
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    {
                        permisions && permisions.allowViewDetail &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.TOUR.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                <Icon 
                                    type={permisions.allowUpdate ? "form" : "eye"}
                                    className="fs20 mr-1" /> 
                                    {permisions.allowUpdate ? t(`action.edit`) : t(`action.show`)}
                            </Link>
                        </Menu.Item>
                    }
                    {
                        permisions && permisions.allowCreate &&
                        <Menu.Item onClick={()=> this.showModal(item)}>
                            <Icon type="plus-square" className="fs20 mr-1" />{t(`action.clone`)}
                        </Menu.Item>
                    }
                    {
                        permisions && permisions.allowDelete &&
                        <Menu.Item onClick={e => this.onRemove(item)}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        )
    }

    onRemove = (item) => {
        const { t } = this.props;
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.tour.title`)),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onDelete && this.props.onDelete(item)
            },
        });
    }

    showModal = (item) => {
        this.setState({ isCloneModalVisible: true, cloneItem: {...item}, isCopyTourTickets: undefined });
    };

    handleOk = () => {
        if (typeof this.state.isCopyTourTickets !== 'boolean') return;

        const lengthOfStay = this.state.cloneItem.lengthOfTour || undefined;
        this.props.cloneTour && this.props.cloneTour(this.state.cloneItem.id, lengthOfStay, this.state.isCopyTourTickets);
        this.setState({ isCloneModalVisible: false, cloneItem: {}, isCopyTourTickets: undefined });
    };

    handleCancel = () => {
        this.setState({ isCloneModalVisible: false, cloneItem: {}, isCopyTourTickets: undefined });
    };

}

export default withTranslation()(TourList);
